import { render, staticRenderFns } from "./Movimentacoes.vue?vue&type=template&id=325ed69e"
import script from "./Movimentacoes.vue?vue&type=script&lang=js"
export * from "./Movimentacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports